// Newsletter subscribe — posts to /api/subscribe (creates verified Ghost member, no magic link)

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ENDPOINT = '/api/subscribe';

function setState(form, state) {
  form.classList.remove('is-success', 'is-error', 'is-loading');
  if (state) form.classList.add('is-' + state);
}

function flashError(target) {
  target.classList.remove('is-error');
  void target.offsetWidth;
  target.classList.add('is-error');
  setTimeout(() => target.classList.remove('is-error'), 2000);
}

async function handleSubmit(form) {
  const email = (form.querySelector('input[type="email"]')?.value || '').trim();
  const consentBox = form.querySelector('.th-newsletter-consent input[type="checkbox"]');
  const honeypot = form.querySelector('input[name="website"]');
  const errEl = form.querySelector('.message-error');
  const okEl = form.querySelector('.message-success');
  const btn = form.querySelector('button[type="submit"]');

  if (!consentBox || !consentBox.checked) {
    flashError(consentBox?.parentElement || form);
    return;
  }

  if (!EMAIL_RE.test(email)) {
    if (errEl) errEl.textContent = 'Please enter a valid email address.';
    setState(form, 'error');
    return;
  }

  setState(form, 'loading');
  if (btn) btn.disabled = true;

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        consent: true,
        website: honeypot ? honeypot.value : '',
      }),
      credentials: 'omit',
    });

    const data = await res.json().catch(() => ({}));

    if (res.ok && data.ok) {
      if (okEl) {
        okEl.textContent = data.already_subscribed
          ? "You're already subscribed. Thanks!"
          : 'Thanks for subscribing!';
      }
      setState(form, 'success');
      form.reset();
      sessionStorage.setItem('th-daily-subscribed', '1');
      scheduleStripDismiss(form);
      return;
    }

    const code = data.error || 'error';
    const msg =
      code === 'rate_limit' ? 'Too many attempts. Please try again in a minute.' :
      code === 'invalid_email' ? 'Please enter a valid email address.' :
      code === 'consent_required' ? 'Please accept the privacy terms.' :
      'Subscription failed. Please try again later.';
    if (errEl) errEl.textContent = msg;
    setState(form, 'error');
  } catch (e) {
    if (errEl) errEl.textContent = 'Network error. Please try again.';
    setState(form, 'error');
  } finally {
    if (btn) btn.disabled = false;
  }
}

// The footer pitch has done its job — after the thank-you beat it slides
// down behind the footer and the page closes up over it.
function dismissStrip(strip, animate) {
  if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    strip.hidden = true;
    return;
  }
  strip.style.maxHeight = strip.scrollHeight + 'px';
  void strip.offsetHeight; // commit the start height before transitioning
  strip.classList.add('is-closing');
  strip.style.maxHeight = '0px';
  strip.addEventListener('transitionend', () => { strip.hidden = true; }, { once: true });
}

function scheduleStripDismiss(form) {
  const strip = form.closest('.th-footer-subscribe');
  if (!strip) return;
  setTimeout(() => dismissStrip(strip, true), 2600);
}

export default function newsletter() {
  // A one-time flag from the earlier permanent version — no longer used
  localStorage.removeItem('th-daily-subscribed');

  // Subscribed in this tab — don't pitch again until the tab is closed
  const strip = document.querySelector('.th-footer-subscribe');
  if (strip && sessionStorage.getItem('th-daily-subscribed') === '1') {
    strip.hidden = true;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('form.th-newsletter-form')) return;
    e.preventDefault();
    e.stopPropagation();
    handleSubmit(form);
  });

  document.addEventListener('change', (e) => {
    if (e.target.type === 'checkbox' && e.target.closest('.th-newsletter-consent')) {
      e.target.parentElement.classList.remove('is-error');
    }
  });
}
